"use client";
import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";
import { ExecEdLeadFormTestResult } from "@/monarch/rules/execEdLeadForm/types";

export default function Header() {
  return (
    <MonarchDataConsumer<ExecEdLeadFormTestResult>
      experimentKey="useExecEdLeadForm"
      render={(testResult) => {
        const { data } = testResult;
        return (
          <h2 className="mb-0 mt-6 text-2xl">
            {data?.headerText || "Get more information"}
          </h2>
        );
      }}
    />
  );
}
